import React, { useState } from 'react';
import { X, Save } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../api';
import { mensajeErrorApi } from '../apiErrors';

export default function EditUsuarioModal({ usuario, onClose, onGuardado }) {
  const [datos, setDatos] = useState({
    first_name: usuario.first_name || '',
    last_name: usuario.last_name || '',
    cedula: usuario.cedula || '',
    whatsapp: usuario.whatsapp || '',
    direccion_entrega_default: usuario.direccion_entrega_default || '',
    ubicacion_maps_link: usuario.ubicacion_maps_link || '',
  });
  const [guardando, setGuardando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!datos.first_name.trim()) return toast.error('El nombre es obligatorio.');
    setGuardando(true);
    try {
      const res = await api.patch(`/usuarios/${usuario.id}/`, datos);
      toast.success('Datos actualizados.');
      onGuardado(res.data);
    } catch (err) {
      toast.error(mensajeErrorApi(err, 'No se pudo actualizar.'));
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '520px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Editar cliente — {usuario.codigo_casillero || usuario.email}</h3>
          <button className="btn-ghost" onClick={onClose}><X size={18} /></button>
        </div>

        <form onSubmit={handleSubmit} className="form-stack">
          <div className="form-row">
            <div>
              <label>Nombre *</label>
              <input value={datos.first_name} onChange={(e) => setDatos({ ...datos, first_name: e.target.value })} required />
            </div>
            <div>
              <label>Apellido</label>
              <input value={datos.last_name} onChange={(e) => setDatos({ ...datos, last_name: e.target.value })} />
            </div>
          </div>

          <div className="form-row">
            <div>
              <label>Cédula</label>
              <input value={datos.cedula} onChange={(e) => setDatos({ ...datos, cedula: e.target.value })} />
            </div>
            <div>
              <label>WhatsApp</label>
              <input value={datos.whatsapp} onChange={(e) => setDatos({ ...datos, whatsapp: e.target.value })} placeholder="+593..." />
            </div>
          </div>

          <div>
            <label>Dirección de entrega</label>
            <textarea rows={2} value={datos.direccion_entrega_default}
              onChange={(e) => setDatos({ ...datos, direccion_entrega_default: e.target.value })} />
          </div>

          <div>
            <label>Link de ubicación (Google Maps)</label>
            <input value={datos.ubicacion_maps_link}
              onChange={(e) => setDatos({ ...datos, ubicacion_maps_link: e.target.value })}
              placeholder="https://maps.google.com/..." />
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary" disabled={guardando}>
              <Save size={16} /> {guardando ? 'Guardando...' : 'Guardar cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
